module.exports = ".row:nth-child(odd){\r\nbackground:#f2f2f2;\r\n}\r\n\r\n.row{\r\n    padding:1em 0em 0em;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/viability-report/viability-form/viability-form.component.css
// module id = ./src/app/landprocurement/viability-report/viability-form/viability-form.component.css
// module chunks = main